import { FC, useContext, useMemo, useState } from 'react';

import { Tabs } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';

import { Bonus } from './Bonus';
import { Clients } from './Clients';
import { HostsOccupation } from './HostsOccupation';
import { ETabs } from './interfaces';
import { PlayAndApplications } from './PlayAndApplications';
import s from './Reports.module.scss';
import { Review } from './Review';
import { Sales } from './Sales';
import { Transfers } from './Transfers';
import { getTabs } from './utils';
import { Visitors } from './Visitors';
import { WorkShifts } from './WorkShifts';

export const Reports: FC = () => {
  const { t } = useContext(LocalizationContext);
  const [tab, setTab] = useState<ETabs>(ETabs.WORKSHIFT);
  const {
    data: { permissions },
  } = useContext(AuthContext);

  const TABS = useMemo(() => getTabs(t, permissions), [t, permissions]);

  return (
    <div className={s.container} data-onboarding-report-tab={ETabs[tab]}>
      <div className={s.tabs_wrapper} data-onboarding="reports-tabs">
        <Tabs
          options={TABS}
          value={tab}
          onChange={setTab}
          itemVariant="row"
          className={s.tabs}
        />
      </div>
      {tab === ETabs.WORKSHIFT && <WorkShifts />}
      {tab === ETabs.REVIEW && (
        <FeatureHOC
          alias="base_reports"
          strategy="replace"
          nameKey="reports.tabs.review"
          grayBG
        >
          <Review />
        </FeatureHOC>
      )}
      {tab === ETabs.CLIENTS && (
        <FeatureHOC
          alias="user_report"
          strategy="replace"
          nameKey="reports.tabs.clients"
          grayBG
        >
          <Clients />
        </FeatureHOC>
      )}
      {tab === ETabs.VISITORS && (
        <FeatureHOC
          alias="visits_report"
          strategy="replace"
          nameKey="reports.tabs.visits"
          grayBG
        >
          <Visitors />
        </FeatureHOC>
      )}
      {tab === ETabs.HOSTS_OCCUPATION && (
        <FeatureHOC
          alias="usage_report"
          strategy="replace"
          nameKey="reports.tabs.hosts"
          grayBG
        >
          <HostsOccupation />
        </FeatureHOC>
      )}
      {tab === ETabs.PLAY_AND_APLLICATIONS && (
        <FeatureHOC
          alias="applications_report"
          strategy="replace"
          nameKey="reports.tabs.applicationReport"
          grayBG
        >
          <PlayAndApplications />
        </FeatureHOC>
      )}
      {tab === ETabs.SALES && (
        <FeatureHOC
          alias="sales_report"
          strategy="replace"
          nameKey="reports.tabs.sales"
          grayBG
        >
          <Sales />
        </FeatureHOC>
      )}
      {tab === ETabs.TRANSFERS && (
        <FeatureHOC
          alias="deposit_transfer"
          strategy="replace"
          nameKey="reports.tabs.transfers"
          grayBG
        >
          <Transfers />
        </FeatureHOC>
      )}
      {tab === ETabs.BONUS && (
        <FeatureHOC
          alias="bonus_report"
          strategy="replace"
          nameKey="money.bonus"
          grayBG
        >
          <Bonus />
        </FeatureHOC>
      )}
    </div>
  );
};
